module.exports = __webpack_public_path__ + "static/media/079-st-barts.aa4c9d67.svg";